export { default as authService }
from './auth.service'
export { default as authInterceptor }
from './auth-interceptor.service'
export { default as eventBus }
from './event-bus.service'
export { default as fileService }
from './file.service'
export { default as formService }
from './form.service'
export { default as httpClient }
from './http-client.service'
export { default as wsClient }
from './ws-client.service'
export { default as userService }
from './user.service'
export { default as chatService }
from './chat.service'
export { default as roleService }
from './role.service'
export { default as deviceService }
from './device.service'
export { default as regionService }
from './region.service'
export { default as vehicleService }
from './vehicle.service'
export { default as driverService }
from './driver.service'
export { default as siteService }
from './site.service'
export { default as tripService }
from './trip.service'
export { default as tripRouteService }
from './tripRoute.service'
export { default as salesdataService }
from './salesdata.service'
export { default as tripExceptionService }
from './tripException.service'
export { default as reportgenerationService }
from './reportgeneration.service'
export { default as firebaseService }
from './firebase.service'
export { default as schedulereportService }
from './schedulereport.service'
export { default as technicianService }
from './technician.service'
export { default as filterService }
from './filter.service'
export { default as exportService }
from './export.service'
export { default as investmentService }
    from './investment.service'

    // export { default as groupService } from './group.service'
    // export { default as permissionService } from './permission.service'
    // export { default as documentService } from './document.service'
    // export { default as chatService } from './chat.service'
    // export { default as statsService } from './stats.service'



// WEBPACK FOOTER //
// ./src/services/index.js